import * as Scrivito from "scrivito"

export const SignInKpiWidget = Scrivito.provideWidgetClass("SignInKpiWidget", {
  attributes: {
    content: "widgetlist"
  }
})
